export const PASSWORD_VISIBLE_NAME = 'password_visible';

export const PASSWORD_HIDDEN_NAME = 'password_hidden';
